import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'filterPipeTicketClosed'
})
export class FilterPipeTicketClosed implements PipeTransform {
    transform(closed_tickets: any, term?: any): any {
        if (term === undefined) return closed_tickets;
        if (term === null) return closed_tickets;

        if (closed_tickets != null) {
            return closed_tickets.filter(function (closed_ticket) {
                if (closed_ticket.number.toString() != undefined)
                    if (closed_ticket.number.toString().toLowerCase().includes(term.toLowerCase()))
                        return closed_ticket;
                if (closed_ticket.cash_static != undefined)
                    if (closed_ticket.cash_static.toString().toLowerCase().includes(term.toLowerCase()))
                        return closed_ticket;
                if (closed_ticket.type != undefined)
                    if (closed_ticket.type.toString().toLowerCase().includes(term.toLowerCase()))
                        return closed_ticket;
                if (closed_ticket.payment_type != undefined)
                    if (closed_ticket.payment_type.toString().toLowerCase().includes(term.toLowerCase()))
                        return closed_ticket;
                if (closed_ticket.amount != undefined)
                    if (closed_ticket.amount.toString().toLowerCase().includes(term.toLowerCase()))
                        return closed_ticket;
                if (closed_ticket.date != undefined)
                    if (moment(new Date(closed_ticket.date.toDate())).format("DD/MM/YYYY HH:mm:ss").toString().toLowerCase().includes(term.toLowerCase()))
                        return closed_ticket.date;
            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-tickets/filter-tclosed.pipe.ts